// this file added by Bearer Web Developer (CancelledByRiderAfterOrigin)
import { Instance, types } from "mobx-state-tree";
interface ICancelledByRiderAfterOrigin {
    message: string;
    open: boolean;
}
export const CancelledByRiderAfterOrigin = types
    .model("CancelledByRiderAfterOrigin", {
        message: types.optional(types.string, ""),
        open: types.optional(types.boolean, false),
    })
    .actions(self => {
        return {
            clear() {
                self.message = '';
                self.open = false;
            },
            setCancelledByRiderAfterOrigin(value: ICancelledByRiderAfterOrigin) {
                self.message = value.message;
                self.open = value.open;
            }
        }
    })
export interface ICancellationCostState extends Instance<typeof CancelledByRiderAfterOrigin> { };

